var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.content,
              expression: "content",
            },
          ],
          class: ["sm-fenji", _vm.showAllContent ? "show" : ""],
        },
        [
          _c("div", { staticClass: "sm-tit" }, [
            _vm._v("\n      " + _vm._s(_vm.plotTitle) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.content,
                expression: "content",
              },
            ],
            staticClass: "sm-con",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
          _vm._v(" "),
          _vm.content.length > 160
            ? _c(
                "div",
                { staticClass: "sm-plot-show", on: { click: _vm.showContent } },
                [_c("span", [_vm._v("阅读全文")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showPlayBtn
            ? _c(
                "div",
                { staticClass: "sm-plot-play", on: { click: _vm.play } },
                [_c("span", [_vm._v("播放本集")])]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isTeleplay && _vm.content
        ? _c("div", { staticClass: "sm-plot-set" }, [
            _c(
              "p",
              {
                class: [_vm.current_ep <= 1 ? "dis" : ""],
                on: { click: _vm.prevEpClick },
              },
              [_vm._v("\n      上一集\n    ")]
            ),
            _vm._v(" "),
            _c("p", { on: { click: _vm.changeComponents } }, [
              _vm._v("\n      选集\n    "),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                class: [_vm.current_ep >= _vm.updating_ep ? "dis" : ""],
                on: { click: _vm.nextEpClick },
              },
              [_vm._v("\n      下一集\n    ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(_vm.current, {
        tag: "component",
        attrs: { "show-ep-comp": _vm.showEpComp },
        on: { hideMask: _vm.hideEpComp },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }